import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 17h3l2-4V7H4v6h3l-2 4zm10 0h3l2-4V7h-6v6h3l-2 4z"
}), 'FormatQuoteSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatQuoteSharp.js
// module id = 3882
// module chunks = 2